export default __webpack_public_path__ + "static/media/thumb_eos.0cb1aee4.png";